import {
  Autocomplete,
  FormControl,
  List,
  ListItem,
  TextField,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useTranslation } from "react-i18next";
import { setSelectedMapFleetId } from "~/redux/reducers/fleetReducer";
import { useAppDispatch, useAppSelector } from "~/redux/store/store";

const useStyles = makeStyles((theme) => ({
  list: {
    width: "100%",
  },
  fleetSelectForm: {
    display: "block",
    width: "100%",
    color: theme.palette.primary.contrastText,
  },
  label: {
    color: `${theme.palette.primary.contrastText} !important`,
  },
  border: {
    borderColor: `${theme.palette.primary.contrastText} !important`,
  },
  select: {
    color: `${theme.palette.primary.contrastText} !important`,
    "&:before": {
      borderColor: `${theme.palette.primary.contrastText} !important`,
    },
    "&:after": {
      borderColor: `${theme.palette.primary.contrastText} !important`,
    },
  },
}));

const FleetLayerSelection = (): JSX.Element => {
  const classes = useStyles();
  const { t } = useTranslation("fleets");
  const allFleets = useAppSelector((s) => s.fleet.allFleets);
  const selectedMapFleetId = useAppSelector((s) => s.fleet.selectedMapFleetId);

  const dispatch = useAppDispatch();

  const handleItemSelection = (value: number | null) => {
    if (!value) {
      dispatch(setSelectedMapFleetId(null));
      return;
    }
    const fleet = allFleets?.find((f) => f.id === value);
    if (!fleet) return;
    dispatch(setSelectedMapFleetId(fleet.id));
  };
  return (
    <List className={classes.list}>
      <ListItem>
        <FormControl className={classes.fleetSelectForm}>
          <Autocomplete
            fullWidth
            disableClearable={false}
            openText={t("general:open")}
            closeText={t("general:close")}
            clearText={t("general:clear")}
            noOptionsText={t("general:no-options")}
            classes={{
              endAdornment: classes.label,
              clearIndicator: classes.label,
              popupIndicator: classes.label,
              popupIndicatorOpen: classes.label,
            }}
            className={classes.select}
            value={selectedMapFleetId}
            onChange={(_e, v) => handleItemSelection(v)}
            options={allFleets?.map((f) => f.id) ?? []}
            getOptionLabel={(opt) =>
              allFleets?.find((f) => f.id === opt)?.fleetName ??
              t("general:unknown")
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("select-fleet")}
                variant="standard"
                classes={{ root: classes.select }}
                InputLabelProps={{
                  ...params.InputLabelProps,
                  className: classes.label,
                }}
                InputProps={{
                  ...params.InputProps,
                  className: classes.select,
                }}
              />
            )}
          />
        </FormControl>
      </ListItem>
    </List>
  );
};

export default FleetLayerSelection;
